
interface CurrencyConfig {
  icon: string;
  locale: string;
  decimalPlaces: number;
}

type CurrencyCode = 'USD' | 'BDT';
// Currency configuration
const currencyConfig: Record<CurrencyCode, CurrencyConfig> = {
  USD: {
    icon: '$',
    locale: 'en-US',
    decimalPlaces: 2,
  },
  BDT: {
    icon: '৳',
    locale: 'bn-BD',
    decimalPlaces: 2,
  },
};

/**
 * Formats a price with its currency icon for BDT or USD
 * @param price - The price to format
 * @param currency - The currency code (BDT or USD)
 * @returns Formatted price with currency icon or '0' if price is null/undefined
 */

export function priceFormatter(
  price: number | string | null | undefined,
  currency: CurrencyCode = 'BDT',
  icon: boolean = true
): string {
  // Handle undefined or null price
  if (price === undefined || price === null) {
    return '0';
  }

  // Convert price to number if it's a string
  const numericPrice: number =
    typeof price === 'string' ? parseFloat(price) : price;

  // Validate the price
  if (isNaN(numericPrice)) {
    return 'Invalid price';
  }

  // Get currency config, default to USD if not found
  const config = currencyConfig[currency] || currencyConfig.BDT;

  try {
    const formatter = new Intl.NumberFormat(config.locale, {
      style: 'decimal',
      minimumFractionDigits: config.decimalPlaces,
      maximumFractionDigits: config.decimalPlaces,
      numberingSystem: 'latn', // Ensure standard digits
    });

    const formattedPrice = formatter.format(numericPrice);
    // If icon is true, prepend the currency icon
    if (icon) {
      return `${config.icon}${formattedPrice}`;
    }
    return formattedPrice;
  } catch (_error) {
    const fallbackPrice = numericPrice.toFixed(config.decimalPlaces);
    return `${config.icon}${fallbackPrice}`;
  }
}

